.userPicture {
  --size: var(--avatar-size, 50px);

  height: var(--size);
  max-width: var(--size);
  min-width: var(--size);
  position: relative;
  user-select: none;
  width: var(--size);
}

.borders .content {
  border: calc(var(--size) / 35) solid var(--comp-card-background-color);
}

.userPicture .content {
  background-color: var(--theme-dark-blue);
  border-radius: 50%;
  height: var(--size);
  overflow: hidden;
  position: relative;
  width: var(--size);
}

.contentItem {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  left: 0;
  object-fit: cover;
  object-position: center;
  position: absolute;
  top: 0;
  width: 100%;
}

.online {
  background-color: #61bd4f;
  border: calc(var(--size) / 35) solid var(--comp-card-background-color);
  border-radius: 50%;
  bottom: calc(var(--size) / 35);
  height: calc(var(--size) / 5);
  position: absolute;
  right: calc(var(--size) / 35);
  width: calc(var(--size) / 5);
}
